import React from 'react'

const CopyrightFooter: React.FC = () => {
  return (
    <div className="bg-main-green w-full text-center absolute bottom-0 py-2">
      <p className="text-sm text-white">
        © 2025 SDGs Lodge. All rights reserved.
      </p>
    </div>
  )
}

export default CopyrightFooter
